import React from "react";
import { Link } from "react-router-dom";
import "./contactbar.css";
import enqiry from '../../assets/icons/enquiry.png'
import call from '../../assets/icons/call.png'
import whatsapp from '../../assets/icons/whatsapp.png'
import tour from '../../assets/icons/tour.png'
function ContactBar() {
  return ( 
    <div className="contactbar" data-aos="fade-up">
        <div className="div1">
            <img src={call} alt="" />
            <p><a href="https://calendly.com/buyersgalaxy/30min?month=2024-11">Call</a></p>
        </div>
        <hr />
        <div className="div1">
            <img src={whatsapp} alt="" />
            <p><a href="https://wa.me/61405564980" target="_blank" rel="noopener noreferrer">Whatsapp</a></p>
        </div>
        <hr />
        <div className="div1">
            <img src={enqiry} alt="" />
            <p><Link to={'/contact'}>Email</Link></p>
        </div> 
        <hr />
        <div className="div1">
            <img src={tour} alt="" />
            <p><Link to={'/download'} >Ebook</Link></p>
        </div>

    </div> 
  );
}
export default ContactBar;
